module.exports = __webpack_public_path__ + "img/clicks_logo.2593efb9.svg";